export class DownTimeReasonDto{
    downtimereasonId?:number;
    downtimeReason?:string;
    downtimestatus?:string;
    createdUser:string;
    isActive: boolean;

    constructor(downtimeReasonId:number,downtimeReason:string,downtimestatus:string,createdUser:string,isActive:boolean){
        this.downtimereasonId = downtimeReasonId;
        this.downtimeReason = downtimeReason;
        this.downtimestatus=downtimestatus;
        this.createdUser =createdUser;
        this.isActive = isActive;
    }
}
export const DowntimeReasonDefault : DownTimeReasonDto = {
    downtimereasonId: 0,
    downtimeReason: "",
    downtimestatus:"",
    createdUser:"",
    isActive:true
};

